import store from "~/lib/store";
import { LAST_LOCATION_KEY } from "~/lib/utils";
import { toast } from "~/ui";

export function activateDelegation(delegatorId: string) {
	fetch("/auth/delegation/activate/", {
		method: "POST",
		credentials: "include",
		body: JSON.stringify({
			/* eslint-disable camelcase */
			delegator_id: delegatorId,
			/* eslint-enable camelcase */
		}),
		headers: {
			"content-type": "application/json; charset=UTF-8",
			"x-client-session-id": window.CLIENT_SESSION_ID,
			"x-csrftoken": window.CSRF_TOKEN,
		},
	})
		.then(response => {
			if (!response.ok) {
				toast.error("Unable to start impersonation.");
				throw new Error("Unable to start impersonation.");
			} else {
				return response.json();
			}
		})
		.then(response => {
			if (response.success) {
				window.navigator.serviceWorker?.controller?.postMessage({ action: "delegationStatusChange" });
				window.location.href = response.redirect;
				store.remove(LAST_LOCATION_KEY);
			}
		});
}

export function deactivateDelegation() {
	fetch("/auth/delegation/deactivate/", {
		method: "POST",
		credentials: "include",
		body: JSON.stringify({}),
		headers: {
			"content-type": "application/json; charset=UTF-8",
			"x-client-session-id": window.CLIENT_SESSION_ID,
			"x-csrftoken": window.CSRF_TOKEN,
		},
	})
		.then(response => {
			if (!response.ok) {
				toast.error("Unable to stop impersonation.");
				throw new Error("Unable to stop impersonation.");
			} else {
				return response.json();
			}
		})
		.then(response => {
			if (response.success) {
				window.navigator.serviceWorker?.controller?.postMessage({ action: "delegationStatusChange" });
				window.location.href = response.redirect;
				store.remove(LAST_LOCATION_KEY);
			}
		});
}
